  (function () {
    'use strict';

    var state = {
      currentController: null,
    };

    function getCartSection() {
      return document.getElementById('cart-page-section');
    }

    function getCartForm() {
      return document.getElementById('cart-page-form');
    }

    function setRowLoading(key, stateLoading) {
      var row = document.querySelector('[data-cart-item][data-item-key="' + key + '"]');
      if (!row) return;

      row.classList.toggle('cart-page__item--loading', stateLoading);
    }

    function parseHTML(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }

    async function fetchSectionHTML() {
      var url = window.location.pathname + '?section_id=cart';

      var res = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!res.ok) throw new Error('Section fetch failed');

      return await res.text();
    }

    async function fetchCartJSON() {
      var res = await fetch(window.Shopify.routes.root + 'cart.js');
      return await res.json();
    }

    async function rerenderCart() {
      var html = await fetchSectionHTML();
      var doc = parseHTML(html);

      var newSection = doc.getElementById('cart-page-section');
      var current = getCartSection();

      if (!newSection || !current) {
        window.location.reload();
        return;
      }

      current.replaceWith(newSection);

      bindEvents();
      refreshHeaderCount();
    }

    async function refreshHeaderCount() {
      try {
        var cart = await fetchCartJSON();

        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      } catch (e) {
        console.error(e);
      }
    }

    async function updateItemQuantity(key, qty) {
      if (!key) return;

      if (state.currentController) {
        state.currentController.abort();
      }

      var controller = new AbortController();
      state.currentController = controller;

      setRowLoading(key, true);

      try {
        var res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: qty,
          }),
          signal: controller.signal,
        });

        if (!res.ok) throw new Error('Cart update failed');

        await res.json();

        await rerenderCart();
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error(err);
          window.location.reload();
        }
      } finally {
        state.currentController = null;
      }
    }

    function handleQtyClick(btn, type) {
      var wrapper = btn.closest('.quantity-selector');
      if (!wrapper) return;

      var input = wrapper.querySelector('[data-quantity-input]');
      if (!input) return;

      var key = input.dataset.cartItemKey;
      var value = parseInt(input.value, 10) || 0;

      if (type === 'minus') value = Math.max(0, value - 1);
      if (type === 'plus') value = value + 1;

      input.value = value;

      updateItemQuantity(key, value);
    }

    function handleQtyInput(input) {
      var key = input.dataset.cartItemKey;
      var val = Math.max(0, parseInt(input.value, 10) || 0);

      input.value = val;

      updateItemQuantity(key, val);
    }

    function bindQuantityEvents(form) {
      form.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-quantity-minus]');
        var plus = e.target.closest('[data-quantity-plus]');
        var rm = e.target.closest('[data-cart-remove]');

        if (minus) {
          e.preventDefault();
          handleQtyClick(minus, 'minus');
        }

        if (plus) {
          e.preventDefault();
          handleQtyClick(plus, 'plus');
        }

        if (rm) {
          e.preventDefault();
          var key = rm.dataset.itemKey;
          updateItemQuantity(key, 0);
        }
      });

      form.addEventListener('change', function (e) {
        var input = e.target.closest('[data-quantity-input]');
        if (!input) return;

        handleQtyInput(input);
      });

      form.addEventListener('keydown', function (e) {
        if (e.target.matches('[data-quantity-input]') && e.key === 'Enter') {
          e.preventDefault();
        }
      });

      form.addEventListener('input', function (e) {
        var input = e.target.closest('[data-quantity-input]');
        if (!input) return;

        input.value = input.value.replace(/[^\d]/g, '');
      });
    }

    function bindDiscountEvents() {
      var btn = document.querySelector('[data-cart-discount-apply]');
      var input = document.querySelector('[data-cart-discount-input]');

      if (!btn || !input) return;

      function apply() {
        var code = input.value.trim();
        if (!code) return;

        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        apply();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          apply();
        }
      });
    }

    function bindEvents() {
      var form = getCartForm();
      if (!form) return;

      bindQuantityEvents(form);
      bindDiscountEvents();
    }

    function init() {
      bindEvents();
      refreshHeaderCount();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();